import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useStepFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import GiftBoxFragment from './fragments/GiftBoxFragment';
import GiftCategoryFragment from './fragments/GiftCategoryFragment';
import GiftMainFragment from './fragments/GiftMainFragment';

interface Params {
    type: 'MAIN' | 'CATEGORY' | 'BOX';
}

declare module '@stackflow/config' {
    interface Register {
        GiftsActivity: Params;
    }
}

const GiftsActivity: ActivityComponentType<'GiftsActivity'> = ({ params }) => {
    const { type } = params;
    const { replaceStep } = useStepFlow('GiftsActivity');
    const { t } = useTranslation('gift');
    return (
        <AppScreen>
            <Header title={t('title')} />
            <TabList variant='solid'>
                <TabItem selected={type === 'MAIN'}
                    onClick={() => replaceStep({ type: 'MAIN' })} >
                    {t('tabs.main')}
                </TabItem>
                <TabItem selected={type === 'CATEGORY'}
                    onClick={() => replaceStep({ type: 'CATEGORY' })} >
                    {t('tabs.category')}
                </TabItem>
                <TabItem selected={type === 'BOX'}
                    onClick={() => replaceStep({ type: 'BOX' })} >
                    {t('tabs.box')}
                </TabItem>
            </TabList>
            {type === 'MAIN' && (
                <GiftMainFragment/>
            )}
            {type === 'CATEGORY' && (
                <GiftCategoryFragment/>
            )}
            {type === 'BOX' && (
                <GiftBoxFragment/>
            )}
        </AppScreen>
    );
};

export default GiftsActivity;
